var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17.258 9.65229C17.6182 9.23367 17.5709 8.60227 17.1523 8.24203C16.7336 7.88179 16.1022 7.92912 15.742 8.34775L12.5101 12.1035C11.826 12.8675 11.3815 13.3601 11.0065 13.6753C10.6551 13.9707 10.4906 14 10.3808 14C10.271 14 10.1066 13.9707 9.75516 13.6753C9.3789 13.359 8.93278 12.8643 8.24503 12.0962C7.87664 11.6847 7.24444 11.6498 6.83297 12.0182C6.4215 12.3865 6.38657 13.0188 6.75496 13.4302L6.80195 13.4827C7.42922 14.1834 7.96989 14.7874 8.46832 15.2063C9.00399 15.6566 9.61243 16 10.3808 16C11.1492 16 11.7577 15.6566 12.2933 15.2063C12.7918 14.7874 13.3324 14.1835 13.9597 13.4827L14.0132 13.4229L17.258 9.65229Z",
    fill: "#3578BD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioSelected);
export default __webpack_public_path__ + "static/media/RadioSelected.a523a728e3c7999bb8d7eced804f0325.svg";
export { ForwardRef as ReactComponent };